import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "cancel-or-recover-an-upload",
  courseId: "reports-from-audio",
  order: 10,
  title: "Cancel or recover",
  subtitle: "Handle a stuck upload",
  summary:
    "A long job is not always a stuck one. Here is how to tell, how to cancel while files are still uploading, and how to start again without re-uploading.",
  learn: [
    "Tell a normal long job from a stuck one",
    "Cancel an upload and clean up its files",
    "Start again from Previous Uploads instead of re-uploading",
  ],
  minutes: 3,
  sceneId: "cancel-or-recover-an-upload",
  tourId: "cancel-or-recover-an-upload",
  releasedAt: "2025-06-01T00:00:00.000Z",
  body: [
    {
      type: "paragraph",
      text: "Transcription runs on servers, not in your browser. A one-minute narrative takes a minute or two. A two-hour interview or a large body-cam file can take considerably longer, and the draft only starts once every file in the case is done.",
    },
    { type: "heading", text: "Is it stuck?" },
    {
      type: "bullets",
      items: [
        "The processing screen reads \"You can safely leave this page. Processing will continue in the background.\" That is normal. Leave and come back.",
        "An upload progress bar that stops moving while the tab is open usually means the connection dropped. Reload and check whether the case exists in **Cases**.",
        "A case that shows an error state has failed on the server. An hourly cleanup also marks abandoned uploads as failed, so a case left half-uploaded overnight will show an error the next morning.",
      ],
    },
    { type: "heading", text: "Cancel and start over" },
    {
      type: "steps",
      items: [
        "Open the processing case.",
        "While the files are still uploading, click **Cancel upload** on the progress toast at the bottom of the screen.",
        "Click **New Case**, then **Upload Files**.",
        "Click **Previous Uploads** to reuse a file that already reached the server.",
      ],
    },
    {
      type: "paragraph",
      text: "Cancelling aborts the in-flight upload, deletes the files already sent, stops any running transcription jobs, and moves the case to **Trash**. Once processing has started there is no cancel button. Let it finish, then delete the case.",
    },
    {
      type: "callout",
      tone: "tip",
      text: "For files over a few hundred megabytes, use the \"Download our file compressor\" link in the upload modal first. Smaller files upload faster and fail less.",
    },
    {
      type: "callout",
      tone: "note",
      text: "If a case keeps failing on the same file, the file itself is usually the problem (corrupt, silent, or an unsupported codec). Play it locally before you upload it again.",
    },
    {
      type: "paragraph",
      text: "If you were combining several recordings, \"Combine recordings\" explains why one failed file holds up the whole draft.",
    },
  ],
  related: ["combine-narrative-and-interaction", "body-cam-footage", "the-files-library"],
};

export default lesson;
